import Vue from 'vue'
import VueRouter from 'vue-router'
import loginService from '../services/login.service';
import userService from '../services/user.service';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta :{
      log:true,
      admin : true,
      auth: true
    }
    
  },
  {
    path: '/query',
    name: 'Query',
    component: () => import('../views/query.vue'),
    beforeEnter: (to, from, next) => { 
      let token = userService.getToken()
      let user = userService.decode(token)
     
      if(user.num ==15177117 || user.num == 10109 || user.num == 10291 || user.num == 501161 || user.num == 990012 ){
        next();  
      }else{
        next('/')
      }
      
    } ,
    meta :{
      log:true,
      admin : true,
      auth: true
    }
    
    
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    beforeEnter: (to, from, next) => { 
      if(loginService.tokenexp()){
        delete localStorage.token; //token expirado
        delete localStorage.min;
      }
      if(loginService.athexp()){
        delete localStorage.ath; 
      }
      next();  
    } 
  },
  {
    path: '*',
    name: 'error',
    beforeEnter: (to, from, next) => { 
      next('/login');  
    } 
  },

  {
    path: '/auth',
    name: 'autentificacion',
    component: () => import('../views/autentificacion.vue'), 
    meta :{
      log:true,
      admin : true
    }
  },

  {
    path: '/send',
    name: 'sendPass',
    component: () => import('../views/sendPass.vue'), 
  },
  //LA PAZ-------------------------------------------------------------------
  {
    path: '/lapaz/corte/:user',
    name: 'corte',
    component: () => import('../views/lapaz/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/corte/:user/buzon',
    name: 'survey',
    component: () => import('../views/Survey.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/almacen/:user',
    name: 'almacen',
    component: () => import('../views/lapaz/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/choferlocal/:user',
    name: 'chofer',
    component: () => import('../views/lapaz/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/chofercedi/:user',
    name: 'cedi',
    component: () => import('../views/lapaz/Cedi.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/vigueta/:user',
    name: 'vigueta',
    component: () => import('../views/lapaz/Vigueta.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/bloquera/:user',
    name: 'bloqueraLaPaz',
    component: () => import('../views/lapaz/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/mantenimiento/:user',
    name: 'mantenimientoLaPaz',
    component: () => import('../views/lapaz/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/bonogarantia/:user',
    name: 'bonogarantiaLaPaz',
    component: () => import('../views/lapaz/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/lapaz/almacencedi/:user',
    name: 'almacenCedilapaz',
    component: () => import('../views/lapaz/AlmacenCedi.vue'),
    meta :{
      log:true
    }
  },
  //JUAREZ-------------------------------------------------------------------

  {
    path: '/juarez/mcsframe/:user',
    name: 'mcsframe',
    component: () => import('../views/juarez/McsFrame.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/bloquera/:user',
    name: 'bloqueraJuarez',
    component: () => import('../views/juarez/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/aligerante/:user',
    name: 'aligerante',
    component: () => import('../views/juarez/Aligerante.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/almacen/:user',
    name: 'almacenJuarez',
    component: () => import('../views/juarez/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/aosmith/:user',
    name: 'aosmith',
    component: () => import('../views/juarez/Aosmith.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/choferlocal/:user',
    name: 'choferes',
    component: () => import('../views/juarez/Choferes.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/commscope/:user',
    name: 'commscope',
    component: () => import('../views/juarez/Commscope.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/corte/:user',
    name: 'corteJuarez',
    component: () => import('../views/juarez/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/electrolux/:user',
    name: 'electrolux',
    component: () => import('../views/juarez/Electrolux.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/molino/:user',
    name: 'molino',
    component: () => import('../views/juarez/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/placa/:user',
    name: 'placa',
    component: () => import('../views/juarez/Placa.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/mantenimiento/:user',
    name: 'mantenimientoJuarez',
    component: () => import('../views/juarez/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/bonogarantia/:user',
    name: 'bonogarantiaJuarez',
    component: () => import('../views/juarez/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/chofercedi/:user',
    name: 'cediJz',
    component: () => import('../views/juarez/Cedi.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/juarez/almacencedi/:user',
    name: 'almacenCedijuarez',
    component: () => import('../views/juarez/AlmacenCedi.vue'),
    meta :{
      log:true
    }
  },
  //CANCUN-------------------------------------------------------------------
  {
    path: '/cancun/almacen/:user',
    name: 'almacenCun',
    component: () => import('../views/cancun/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cancun/corte/:user',
    name: 'corteCun',
    component: () => import('../views/cancun/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cancun/mantenimiento/:user',
    name: 'mantenimientoCun',
    component: () => import('../views/cancun/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cancun/bloquera/:user',
    name: 'bloqueraCun',
    component: () => import('../views/cancun/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cancun/bonogarantia/:user',
    name: 'bonogarantiaCun',
    component: () => import('../views/cancun/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cancun/choferlocal/:user',
    name: 'choferCul',
    component: () => import('../views/cancun/Chofer.vue'),
    meta :{
      log:true
    }
  },
  // {
  //   path: '/cancun/trafico/:user',
  //   name: 'corteCun',
  //   component: () => import('../views/cancun/Trafico.vue'),
    // meta :{
    //   log:true
    // }
  // },
  //CDMEX-------------------------------------------------------------------
  {
    path: '/cdmexico/corte/:user',
    name: 'cortecdmex',
    component: () => import('../views/cdmex/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmexico/almacen/:user',
    name: 'almacenCdmx',
    component: () => import('../views/cdmex/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmexico/vitro/:user',
    name: 'vitrocdmex',
    component: () => import('../views/cdmex/Vitro.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmexico/mantenimiento/:user',
    name: 'mantenimientocdmex',
    component: () => import('../views/cdmex/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmexico/bloquera/:user',
    name: 'bloqueracdmex',
    component: () => import('../views/cdmex/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmex/bonogarantia/:user',
    name: 'bonogarantiacdmex',
    component: () => import('../views/cdmex/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/cdmexico/trafico/:user',
    name: 'traficocdmex',
    component: () => import('../views/cdmex/Trafico.vue'),
    meta :{
      log:true
    }
  },
//CULIACAN-------------------------------------------------------------------
    {
      path: '/culiacan/almacen/:user',
      name: 'almacenCul',
      component: () => import('../views/culiacan/Almacen.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/corte/:user',
      name: 'corteCul',
      component: () => import('../views/culiacan/Corte.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/choferlocal/:user',
      name: 'choferCul',
      component: () => import('../views/culiacan/Chofer.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/panel/:user',
      name: 'panelCul',
      component: () => import('../views/culiacan/Panel.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/bloquera/:user',
      name: 'bloqueraCul',
      component: () => import('../views/culiacan/Bloquera.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/mantenimiento/:user',
      name: 'mantenimientoCul',
      component: () => import('../views/culiacan/Mantenimiento.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/culiacan/bonogarantia/:user',
      name: 'bonogarantiaCul',
      component: () => import('../views/culiacan/Bono.vue'),
      meta :{
        log:true
      }
    },
//GUADALAJARA-------------------------------------------------------------------
    {
      path: '/guadalajara/corte/:user',
      name: 'corteGdlj',
      component: () => import('../views/guadalajara/Corte.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/emcorte/:user',
      name: 'emcorteGdlj',
      component: () => import('../views/guadalajara/Emcorte.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/choferlocal/:user',
      name: 'choferGdlj',
      component: () => import('../views/guadalajara/Chofer.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/bloquera/:user',
      name: 'bloqueraGdlj',
      component: () => import('../views/guadalajara/Bloquera.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/almacen/:user',
      name: 'almacenGdlj',
      component: () => import('../views/guadalajara/Almacen.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/insulpanel/:user',
      name: 'insulpanelGdlj',
      component: () => import('../views/guadalajara/Insulpanel.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/mantenimiento/:user',
      name: 'mantenimientoGdlj',
      component: () => import('../views/guadalajara/Mantenimiento.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/molino/:user',
      name: 'molinoGdl',
      component: () => import('../views/guadalajara/Molino.vue'),
      meta :{
        log:true
      }
    },
    {
      path: '/guadalajara/bonogarantia/:user',
      name: 'bonogarantiaGdlj',
      component: () => import('../views/guadalajara/Bono.vue'),
      meta :{
        log:true
      }
    },
//HERMOSILLO-------------------------------------------------------------------
  {
    path: '/hermosillo/almacen/:user',
    name: 'almacenHillo',
    component: () => import('../views/hermosillo/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/molino/:user',
    name: 'molinoGdl',
    component: () => import('../views/hermosillo/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/empaquerotulado/:user',
    name: 'EmpaqueRotuladoHmo',
    component: () => import('../views/hermosillo/EmpaqueRotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/rotuladotemp/:user',
    name: 'RotuladoTempHmo',
    component: () => import('../views/hermosillo/RotuladoTemp.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/bloquera/:user',
    name: 'bloqueraHillo',
    component: () => import('../views/hermosillo/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/choferlocal/:user',
    name: 'choferHillo',
    component: () => import('../views/hermosillo/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/corte/:user',
    name: 'corteHillo',
    component: () => import('../views/hermosillo/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/insulpanel/:user',
    name: 'insulpanelHillo',
    component: () => import('../views/hermosillo/Insulpanel.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/mantenimiento/:user',
    name: 'mantenimientoHillo',
    component: () => import('../views/hermosillo/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/moldeo/:user',
    name: 'moldeoHillo',
    component: () => import('../views/hermosillo/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/steelfoam/:user',
    name: 'steelfoamHillo',
    component: () => import('../views/hermosillo/Steelfoam.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/rotulado/:user',
    name: 'rotuladoHmo',
    component: () => import('../views/hermosillo/Rotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/bonogarantia/:user',
    name: 'bonogarantiaHillo',
    component: () => import('../views/hermosillo/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/hermosillo/preexpansion/:user',
    name: 'preexpansionHmo',
    component: () => import('../views/hermosillo/Preexpansion.vue'),
    meta :{
      log:true
    }
  },
  //Mexicali-------------------------------------------------------------------
  {
    path: '/mexicali/almacen/:user',
    name: 'almacenMxl',
    component: () => import('../views/mexicali/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/bloquera/:user',
    name: 'bloqueraMxl',
    component: () => import('../views/mexicali/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/choferlocal/:user',
    name: 'choferMxl',
    component: () => import('../views/mexicali/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/corte/:user',
    name: 'corteMxl',
    component: () => import('../views/mexicali/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/insulpanel/:user',
    name: 'insulpanelMxl',
    component: () => import('../views/mexicali/Insulpanel.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/mantenimiento/:user',
    name: 'mantenimientoMxl',
    component: () => import('../views/mexicali/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/moldeo/:user',
    name: 'moldeoMxl',
    component: () => import('../views/mexicali/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/rotulado/:user',
    name: 'rotuladoMxl',
    component: () => import('../views/mexicali/Rotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/bonogarantia/:user',
    name: 'bonogarantiaMxl',
    component: () => import('../views/mexicali/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/preexpansion/:user',
    name: 'preexpansionMxl',
    component: () => import('../views/mexicali/Preexpansion.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/preexpansionmoldeo/:user',
    name: 'preexpansionmoldeoMxl',
    component: () => import('../views/mexicali/PreexpansionMoldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/bonotyg/:user',
    name: 'bonotygMxl',
    component: () => import('../views/mexicali/Bonotyg.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/steelfoam/:user',
    name: 'steelfoamMxl',
    component: () => import('../views/mexicali/Steelfoam.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/mexicali/molino/:user',
    name: 'molinoMxl',
    component: () => import('../views/mexicali/Molino.vue'),
    meta :{
      log:true
    }
  },
//MERIDA -------------------------------------------------------------------
  {
    path: '/merida/almacen/:user',
    name: 'almacenMerida',
    component: () => import('../views/merida/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/bloquera/:user',
    name: 'bloqueraMerida',
    component: () => import('../views/merida/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/choferlocal/:user',
    name: 'choferMerida',
    component: () => import('../views/merida/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/corte/:user',
    name: 'corteMerida',
    component: () => import('../views/merida/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/mantenimiento/:user',
    name: 'mantenimientoMerida',
    component: () => import('../views/merida/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/moldeo/:user',
    name: 'moldeoMerida',
    component: () => import('../views/merida/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/rotulado/:user',
    name: 'rotuladoMda',
    component: () => import('../views/merida/Rotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/merida/bonogarantia/:user',
    name: 'bonogarantiaMda',
    component: () => import('../views/merida/Bono.vue'),
    meta :{
      log:true
    }
  },
  //MONTERREY -------------------------------------------------------------------
  {
    path: '/monterrey/almacen/:user',
    name: 'almacenMty',
    component: () => import('../views/monterrey/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/bloquera/:user',
    name: 'bloqueraMty',
    component: () => import('../views/monterrey/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/emcorte/:user',
    name: 'emcorteMty',
    component: () => import('../views/monterrey/Emcorte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/mantenimiento/:user',
    name: 'mantenimientoMty',
    component: () => import('../views/monterrey/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/moldeo/:user',
    name: 'moldeoMty',
    component: () => import('../views/monterrey/Moldeo.vue'),
    meta :{
      log:true
    }    
  },
  {
    path: '/monterrey/choferlocal/:user',
    name: 'choferlocalMty',
    component: () => import('../views/monterrey/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/chofercedi/:user',
    name: 'cediMTY',
    component: () => import('../views/monterrey/Cedi.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/cortenip/:user',
    name: 'cortenipMty',
    component: () => import('../views/monterrey/Cortenip.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/corte/:user',
    name: 'corteMty',
    component: () => import('../views/monterrey/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/molino/:user',
    name: 'molinoMty',
    component: () => import('../views/monterrey/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/rotulado/:user',
    name: 'rotuladoMty',
    component: () => import('../views/monterrey/Rotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/empaquerotulado/:user',
    name: 'EmpaqueRotuladoMty',
    component: () => import('../views/monterrey/EmpaqueRotulado.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/bonogarantia/:user',
    name: 'bonogarantiaMty',
    component: () => import('../views/monterrey/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/monterrey/preexpansion/:user',
    name: 'preexpansionMTY',
    component: () => import('../views/monterrey/Preexpansion.vue'),
    meta :{
      log:true
    }
  },
//NOGALES -------------------------------------------------------------------
   {
    path: '/nogales/almacen/:user',
    name: 'almacenNog',
    component: () => import('../views/nogales/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/molino/:user',
    name: 'molinoNog',
    component: () => import('../views/nogales/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/bloquera/:user',
    name: 'bloqueraNog',
    component: () => import('../views/nogales/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/corte/:user',
    name: 'corteNog',
    component: () => import('../views/nogales/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/emcorte/:user',
    name: 'emcorteNog',
    component: () => import('../views/nogales/Emcorte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/moldeo/:user',
    name: 'moldeoNog',
    component: () => import('../views/nogales/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/preexpansion/:user',
    name: 'preexpansionNog',
    component: () => import('../views/nogales/Preexpansion.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/choferlocal/:user',
    name: 'choferlocalNog',
    component: () => import('../views/nogales/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/mantenimiento/:user',
    name: 'mantenimientoNog',
    component: () => import('../views/nogales/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/nogales/bonogarantia/:user',
    name: 'bonogarantiaNog',
    component: () => import('../views/nogales/Bono.vue'),
    meta :{
      log:true
    }
  },
//QUERETARO -------------------------------------------------------------------
  {
    path: '/queretaro/almacen/:user',
    name: 'almacenQro',
    component: () => import('../views/queretaro/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/molino/:user',
    name: 'molinoQro',
    component: () => import('../views/queretaro/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/bloquera/:user',
    name: 'bloqueraQro',
    component: () => import('../views/queretaro/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/corte/:user',
    name: 'corteQro',
    component: () => import('../views/queretaro/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/moldeo/:user',
    name: 'moldeoQro',
    component: () => import('../views/queretaro/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/choferlocal/:user',
    name: 'choferlocalQro',
    component: () => import('../views/queretaro/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/mantenimiento/:user',
    name: 'mantenimientoQro',
    component: () => import('../views/queretaro/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/bonogarantia/:user',
    name: 'bonogarantiaQro',
    component: () => import('../views/queretaro/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/queretaro/preexpansion/:user',
    name: 'preexpansionQro',
    component: () => import('../views/queretaro/Preexpansion.vue'),
    meta :{
      log:true
    }
  },
//TIJUANA -------------------------------------------------------------------
  {
    path: '/tijuana/almacen/:user',
    name: 'almacenTij',
    component: () => import('../views/tijuana/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/bloquera/:user',
    name: 'bloqueraTij',
    component: () => import('../views/tijuana/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/bonotyg/:user',
    name: 'bonotygTij',
    component: () => import('../views/tijuana/Bonotyg.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/bonogarantia/:user',
    name: 'bonogarantiaTij',
    component: () => import('../views/tijuana/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/corte/:user',
    name: 'corteTij',
    component: () => import('../views/tijuana/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/cortemaq/:user',
    name: 'corteMaqTij',
    component: () => import('../views/tijuana/Cortemaq.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/molino/:user',
    name: 'molinoTij',
    component: () => import('../views/tijuana/Molino.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/choferlocal/:user',
    name: 'choferlocalTij',
    component: () => import('../views/tijuana/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/tijuana/mantenimiento/:user',
    name: 'mantenimientoTij',
    component: () => import('../views/tijuana/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
//VERACRUZ -------------------------------------------------------------------
  {
    path: '/veracruz/emcorte/:user',
    name: 'emcorteVeracruz',
    component: () => import('../views/veracruz/Emcorte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/moldeo/:user',
    name: 'moldeoVeracruz',
    component: () => import('../views/veracruz/Moldeo.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/bloquera/:user',
    name: 'bloqueraVeracruz',
    component: () => import('../views/veracruz/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/almacen/:user',
    name: 'almacenVeracruz',
    component: () => import('../views/veracruz/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/almacencedi/:user',
    name: 'almacenCediVeracruz',
    component: () => import('../views/veracruz/AlmacenCedi.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/corte/:user',
    name: 'corteVz',
    component: () => import('../views/veracruz/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/panel/:user',
    name: 'panelVz',
    component: () => import('../views/veracruz/Panel.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/choferlocal/:user',
    name: 'choferVz',
    component: () => import('../views/veracruz/Chofer.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/chofercedi/:user',
    name: 'cediVz',
    component: () => import('../views/veracruz/Cedi.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/mantenimiento/:user',
    name: 'mantenimientoVz',
    component: () => import('../views/veracruz/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/steelfoam/:user',
    name: 'steelfoamVz',
    component: () => import('../views/veracruz/Steelfoam.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/veracruz/bonogarantia/:user',
    name: 'bonogarantiaVz',
    component: () => import('../views/veracruz/Bono.vue'),
    meta :{
      log:true
    }
  },
  //VILLAHERMOSA -------------------------------------------------------------------
  {
    path: '/villahermosa/bloquera/:user',
    name: 'bloqueraVillaH',
    component: () => import('../views/villahermosa/Bloquera.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/villahermosa/corte/:user',
    name: 'corteVillaH',
    component: () => import('../views/villahermosa/Corte.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/villahermosa/bonogarantia/:user',
    name: 'bonogarantiaVillaH',
    component: () => import('../views/villahermosa/Bono.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/villahermosa/almacen/:user',
    name: 'almacenVillaH',
    component: () => import('../views/villahermosa/Almacen.vue'),
    meta :{
      log:true
    }
  },
  {
    path: '/villahermosa/mantenimiento/:user',
    name: 'mantenimientoVillaH',
    component: () => import('../views/villahermosa/Mantenimiento.vue'),
    meta :{
      log:true
    }
  },

  //---------------------------------------------------------------------------

  {
    path: '/:city/:depto/:user/historial',
    name: 'historial',
    component: () => import('../views/historial.vue'),
    meta :{
      log:true
    }
  },

  {
    path: '/:city/:depto/:user/buzon',
    name: 'buzon',
    component: () => import('../views/Survey.vue'),
    meta :{
      log:true
    }
  },

  {
    path: '/:city/:depto/:user/buzon-end',
    name: 'buzon-end',
    component: () => import('../views/Survey-End.vue'),
    meta :{
      log:true
    }
  },

  {
    path: '/:city/:depto/:user/calculadora',
    name: 'calculadora',
    component: () => import('../views/Video.vue'),
    meta :{
      log:true
    }
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
   let check = loginService.checkIdentity();
   let meta_admin = to.matched.some(record=>record.meta.admin);
   let meta_log = to.matched.some(record=>record.meta.log);
   let meta_auth = to.matched.some(record=>record.meta.auth);
  
   if (to.path === '/login' )  return next()  
   if (to.path === '/send' )  return next()  
   if(loginService.tokenexp()){
    delete localStorage.token; //token expirado
    delete localStorage.ath; 
    delete localStorage.min
    next('/login')
  }
   if(check && meta_log){
      let admin = loginService.isAdmin();
      let ath = loginService.getAth();
      if (to.path === '/auth' && admin)  return next();
      if(meta_admin){
          if(admin){
           if(meta_auth){
              if(ath.auth=='valido'){
                next();
              }else{
                next('/auth')
              }
           }else{ // rutas de colaboradores 
              if(ath.auth=='valido'){
                next();
              }else{
                next('/auth')
              }
           }
          }else{
            let identity = loginService.getIdentity();
            next(`${identity.city}/${identity.depto}/${identity.num}`) // es colaborador
            if(to.path === `/${identity.city}/${identity.depto}/${identity.num}/historial` ) return next();
            if(to.path === `/${identity.city}/${identity.depto}/${identity.num}/buzon` ) return next();
            if(to.path === `/${identity.city}/${identity.depto}/${identity.num}/buzon-end` ) return next();
            if(to.path === `/${identity.city}/${identity.depto}/${identity.num}/calculadora` ) return next();
          }
      }else{ //rutas especificas de colaborador
        if(admin){ // si la ruta no requiere admin pero si es admin que verifique que este autentificado
          if(ath.auth=='valido'){ 
            next();
          }else{
            next('/auth')
          }
         }else{
            next();
         }
      }

   }else{
     next('/login')
   }

});

export default router
